import { personAddressFrag } from '../../../../service/types/person.types';

export const getMedicationNameFrag = `
    name
    nameAddition
`;

export const medicationFrag = `
    id
    medicationCode
    customMedication
    folderId
    folder {
        person {
            name
            surname
            birthdate
            addresses {
                ${personAddressFrag}
            }
        }
    }
    serviceId
    customMedicationName
    active
    to
    packageTo
`;
